import * as C from '../constants';

export default {

  /**
   * Sets session info
   *
   * @param commit
   * @param payload
   */
  setSessionInfo({ commit }, payload) {
    return new Promise((resolve) => {
      commit(C.APP_SESSION_INFO_SET, payload);
      resolve();
    });
  },

  /**
   * Resets session info
   *
   * @param commit
   * @returns {Promise<any>}
   */
  resetSessionInfo({ commit }) {
    return new Promise((resolve) => {
      commit(C.APP_SESSION_INFO_SET, { user: null, brands: null, products: null, suppliers: null });
      resolve();
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js